export interface PromiseWrapper<T> {
  readonly promise: Promise<T>;
  readonly resolve: (value?: T) => void;
  readonly reject: (error: unknown) => void;
  readonly isFulfilled: () => boolean;
}

export function createPromiseWrapper<T>(): PromiseWrapper<T> {
  let promiseResolve: (value: T) => void;
  let promiseReject: (error: unknown) => void;
  let isFulfilled = false;

  const promise = new Promise<T>((resolve, reject) => {
    promiseResolve = resolve;
    promiseReject = reject;
  });

  return {
    promise,
    resolve: (value) => {
      isFulfilled = true;
      promiseResolve(value ?? (undefined as unknown as T));
    },
    reject: (error) => {
      isFulfilled = true;
      promiseReject(error);
    },
    isFulfilled: () => isFulfilled,
  };
}
